"use client";

const variantStyles = {
  green: "bg-emerald-50 border-emerald-100",
  blue: "bg-slate-50 border-slate-200",
  red: "bg-rose-50 border-rose-100",
  orange: "bg-amber-50 border-amber-100",
  yellow: "bg-amber-50 border-amber-100",
};

const variantValues = {
  green: "text-emerald-700",
  blue: "text-slate-800",
  red: "text-rose-700",
  orange: "text-amber-700",
  yellow: "text-amber-700",
};

export default function MetricCard({ label, value, note, variant, icon }) {
  return (
    <div
      className={`rounded-xl border p-4 min-h-[130px] flex flex-col justify-between shadow-sm ${variantStyles[variant]}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-sm font-medium text-gray-500">{label}</div>
          <div className={`text-[clamp(22px,2.5vw,30px)] font-bold leading-none mt-2 ${variantValues[variant]}`}>{value}</div>
        </div>
        {icon && <div className="p-3 rounded-full bg-white/70">{icon}</div>}
      </div>
      <div className="text-[13px] text-slate-500">{note}</div>
    </div>
  );
}
